import React, { useState, useEffect } from "react"
import ServiceRow from "../ServiceRow"

import style from "./index.module.sass"
// ----------------------------------------------------------------------------

function FeaturedSection(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { services, onShowModal, orderingEnabled, sections, promotion } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // count how many items to display in the carousel based on screen width
  const [itemsCount, setItemsCount] = useState(0)

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      if (window.innerWidth > 1200) {
        setItemsCount(3)
      } else if (window.innerWidth > 768) {
        setItemsCount(2)
      } else {
        setItemsCount(1)
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize)
  }, []) // Empty array ensures that effect is only run on mount

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function getCorrespSectionPartConfigs(service) {
    return sections.find(section => {
      return section.services.includes(s => {
        return s.id == service.id
      })
    })?.service_section_part_configs || []
  }

  // ----------------------------------------------------------------------------
  // Render Functions
  // ----------------------------------------------------------------------------

  function renderServices() {
    if (itemsCount === 0) {
      return []
    }
    // keep 3 services in each carousel page
    let domServices = []
    let remainingServices = [...services]
    while (remainingServices.length > 0) {
      let currentServices = remainingServices.splice(0, itemsCount)
      let currentCarouselItem = currentServices.map((service) => {
        let expand = ""
        if (currentServices.length === 3) {
          expand = style.expand33percent
        }
        if (currentServices.length === 2) {
          expand = style.expand50percent
        }
        return (
          <div
            key={service.id}
            className={`${style.serviceContainer} ${expand}`}
          >
            <ServiceRow
              isFixedHeight={true}
              service={service}
              serviceSectionPartConfigs={getCorrespSectionPartConfigs()}
              orderingEnabled={orderingEnabled}
              onShowModal={onShowModal}
              promotion={promotion}
            />
          </div>
        )
      })
      domServices.push(currentCarouselItem)
    }
    return domServices.map((el, index) => {
      return (
        <div key={index} className={`item ${index === 0 ? "active" : ""} ${style.minHeight}`}>
          <div
            className={`${style.carouselItemContainer} ${style.height100}`}
          >
            {el}
          </div>
        </div>
      )
    })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={style.container}>
      <div className={style.inner}>
        <div
          className={`${style.arrow}`}
          role="button"
          data-slide="prev"
          href="#carousel-reviews"
        >
          <i className="fas fa-chevron-left"></i>
        </div>
        <div
          style={{
            height: "100%",
            width: "100%",
          }}
        >
          <h2 className={style.title}>{I18n.t("service_ordering.featured_title")}</h2>
          <p className={style.subtitle}>{I18n.t("service_ordering.featured_subtitle")}</p>
          <div
            id="carousel-reviews"
            className={`carousel slide ${style.marginHorizontal}`}
            data-ride="carousel"
          >
            <div className={`carousel-inner`}>
              {renderServices()}
            </div>
          </div>
        </div>
        <div
          className={`${style.arrow}`}
          role="button"
          data-slide="next"
          href="#carousel-reviews"
        >
          <i className="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default FeaturedSection
